import PopupMenu from './PopupMenu';
import PopupMenuContext from './PopupMenuContext';
import PopupMenuGroup from './PopupMenuGroup';
import PopupMenuHeader from './PopupMenuHeader';
import PopupMenuItem from './PopupMenuItem';
import PopupMenuMenu from './PopupMenuMenu';

PopupMenu.Trigger = PopupMenuContext.Consumer;
PopupMenu.Menu = PopupMenuMenu;
PopupMenu.Item = PopupMenuItem;
PopupMenu.Group = PopupMenuGroup;
PopupMenu.Header = PopupMenuHeader;

export default PopupMenu;
